module.exports = __webpack_public_path__ + "img/services_landing_pages.6172d878.png";